module.exports = __webpack_public_path__ + "img/stamp-3-x.0df5a447.png";